import React, { useState } from 'react';
import {
  Col,
  Table,
  Button,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
} from 'reactstrap';
import Input from 'reactstrap/lib/Input';
import ModalCadastroAutoTexto from './modal/cadastro';
import './autotexto.styles.css';
import { useSelector, useDispatch } from 'react-redux';
import Tab from '@material-ui/core/Tab';
import TabPanel from '@material-ui/lab/TabPanel';
import TabContext from '@material-ui/lab/TabContext';
import Tabs from '@material-ui/core/Tabs';
import AppBar from '@material-ui/core/AppBar';
import * as commomactions from '../../common.action';
import { editorUrl } from '../../../../constants/defaultValues';

import IntlMessage from '../../../../helpers/intlMessage';
import ModalVisualizarAutoTexto from './modal/visualizar';

const AutoTexto = (props) => {
  const [showModal, setShowModal] = useState(false);
  const [showText, setShowText] = useState(false);
  const [currentText, setCurrentText] = useState('');
  const dispatch = useDispatch();
  const [currentTab, setCurrentTab] = useState('1');

  const mudarAba = (event, tab) => {
    setCurrentTab(tab);
  };

  function cadastrarAutoTexto(e) {
    const frame = document.getElementById('iframe-editor-component');

    if (frame !== null) {
      return frame.contentWindow.postMessage(
        {
          method: 'recuperarTextoRtfAndPlainText',
          urlHost: editorUrl,
          args: {
            action: 'getRTFandPlainText',
            param: { titulo: e.titulo, atalho: e.atalho, grupo: e.grupo },
          },
        },
        editorUrl
      );
    }
  }

  return (
    <React.Fragment>
      <ModalCadastroAutoTexto
        tabs={currentTab}
        onModal={() => setShowModal(!showModal)}
        showModal={showModal}
        confirmar={(e) => cadastrarAutoTexto(e)}
      />

    <ModalVisualizarAutoTexto
            tabs={currentTab}
            onModal={() => setShowText(!showText)}
            texto={currentText}
            showModal={showText}
          />

<div className='mv-autotexto-container espacamento-container-lateral'>
      <TabContext value={currentTab}>
        <AppBar position='static' color='default'>
          <Tabs
            value={currentTab}
            onChange={mudarAba}
            variant='scrollable'
            scrollButtons='auto'
            indicatorColor='primary'
            textColor='primary'
            style={{width: '100%'}}
          >
            <Tab
              label={<IntlMessage id = "dashboards.examDetail.grouped"/>}
              value='1'
              style={{width: '50%', maxWidth:'50%' }}
            />
            <Tab
              label={<IntlMessage id = "dashboards.examDetail.general"/>}
              value='2'
              style={{width: '50%', maxWidth:'50%' }}
            />

          </Tabs>
        </AppBar>

        <TabPanel value='1' style={{marginTop: 20, marginBottom: 20}}>
      <Col
        style={{
          height: (props.alturaEditor()),
          overflowY: 'auto',
          overflowX: 'hidden',
        }}
      >
        <div className="pesquisa-autotexto">
          <InputGroup>
            <InputGroupAddon addonType="prepend">
              <InputGroupText>
                <i className="fas fa-search"></i>
              </InputGroupText>
            </InputGroupAddon>
            <Input
              value={props.texto}
              type="search"
              onChange={(e) => props.filtrar(e.currentTarget.value)}
            />
            <InputGroupText
              className="add-post btn-primary"
              onClick={() => {
                setShowModal(!showModal)
              }}
            >
              <i className="mv-basico-adicionar"></i>
            </InputGroupText>
          </InputGroup>
        </div>
        {(props.autotexto === undefined || props.autotexto.length === 0) && (
          <p className="mv-semItem"><IntlMessage id = "dashboards.examDetail.noAutoTextRegistered"/></p>
        )}
        {props.autotexto !== undefined && props.autotexto.length > 0 && (
          <div>
            <Table>
              <thead>
                <tr>
                  <th><IntlMessage id = "dashboards.examDetail.shortcut"/></th>
                  <th><IntlMessage id = "dashboards.examDetail.defaultText"/></th>
                </tr>
              </thead>
              <tbody>
                {props.autotexto !== undefined &&
                  props.autotexto.map((item) => {
                    return (
                      <tr
                        key={item.idExameTexto}
                        style={{ wordBreak: 'break-all' }}
                      >
                        <td>{item.identificador}</td>
                        <td onClick={()=>{
                          setCurrentText(item.textoPlainText);
                          setShowText(!showText)}
                          }
                          >{item.nomeTexto}</td>
                        <td>

                        <Button
                          style={{ wordBreak: 'initial', height:'50%'}}
                          size="sm"
                          onClick={() => {
                            props.obterAutotexto(item.textoId);
                          }}
                          color="primary"
                          >
                          <IntlMessage id = "dashboards.examDetail.adding"/>
                          </Button>
                          <br></br>
                          <Button

                            style={{ wordBreak: 'initial', height:'50%', marginTop:'1px'}}
                            size="sm"
                            onClick={() => {
                              setCurrentText(item.textoPlainText);
                              setShowText(!showText);
                            }}
                            color="primary"
                          >
                            <IntlMessage id='dashboards.general.toView'/>
                          </Button>
                        </td>
                      </tr>
                      // </div>
                    );
                  })}
              </tbody>
            </Table>
          </div>
        )}
      </Col>
        </TabPanel>
        <TabPanel value='2'  style={{marginTop: 20, marginBottom: 20}}>
        <Col
        style={{
          height: (props.alturaEditor()),
          overflowY: 'auto',
          overflowX: 'hidden',
        }}
      >
        <div className="pesquisa-autotexto">
          <InputGroup>
            <InputGroupAddon addonType="prepend">
              <InputGroupText>
                <i className="fas fa-search"></i>
              </InputGroupText>
            </InputGroupAddon>
            <Input
              value={props.textoGeral}
              type="search"
              onChange={(e) => props.filtrarGeral(e.currentTarget.value)}
            />
            <InputGroupText
              className="add-post btn-primary"
              onClick={() => {
                setShowModal(!showModal)
              }}
            >
              <i className="mv-basico-adicionar"></i>
            </InputGroupText>
          </InputGroup>
        </div>
        {(props.autotextoGeral === undefined || props.autotextoGeral.length === 0) && (
          <p className="mv-semItem"><IntlMessage id = "dashboards.examDetail.noAutoTextRegistered"/></p>
        )}
        {props.autotextoGeral !== undefined && props.autotextoGeral.length > 0 && (
          <div>
            <Table>
              <thead>
                <tr>
                  <th><IntlMessage id = "general.materialArchiving.identification"/></th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {props.autotextoGeral !== undefined &&
                  props.autotextoGeral.map((item) => {
                    return (
                      <tr
                        key={item.idExameTexto}
                        style={{ wordBreak: 'break-all' }}
                      >
                        <td >{item.nomeTexto}</td>
                        <td>
                          <Button
                            style={{ wordBreak: 'initial', height:'50%' }}
                            size="sm"
                            // id="autotexto-button-adicionar"
                            onClick={() => {
                              props.obterAutotexto(item.textoId);
                            }}
                            color="primary"
                          >
                             <IntlMessage id = "dashboards.examDetail.adding"/>
                          </Button>
                          <br></br>
                          <Button

                            style={{ wordBreak: 'initial', height:'50%', marginTop:'1px'}}
                            size="sm"
                            onClick={() => {
                              setCurrentText(item.textoPlainText);
                              setShowText(!showText);
                            }}
                            color="primary"
                          >
                            <IntlMessage id='dashboards.general.toView'/>
                          </Button>
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </Table>
          </div>
        )}
      </Col>
        </TabPanel>
      </TabContext>
    </div>
    </React.Fragment>
  );
};

export default AutoTexto;



// WEBPACK FOOTER //
// ./src/app/common/tabs/autotexto/autotexto.page.js